import { BandChart } from '@toggle/design-system';
import styled from 'styled-components';

export const BandChartWrapper = styled.div<{ $color: string }>`
  & svg {
    height: 240px;
  }

  ${BandChart.Styled.LinePlot} {
    color: ${({ $color }) => $color};
    stroke-width: 1px;
  }
`;
